// Create an Admin Management Component (src/components/AdminManagement.js)
import React, { useState, useEffect } from 'react';
import { auth } from '../firebase/config';
import { getFunctions, httpsCallable } from 'firebase/functions';
import './AdminManagement.css';

const AdminManagement = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const functions = getFunctions();

  useEffect(() => {
    // Check if current user is admin
    const checkAdminStatus = async () => {
      const token = await auth.currentUser?.getIdTokenResult();
      setIsAdmin(token?.claims?.admin === true);
    };

    checkAdminStatus();
  }, []);

  const makeAdmin = async (e) => {
    e.preventDefault();
    
    try {
      const addAdminRole = httpsCallable(functions, 'addAdminRole');
      const result = await addAdminRole({ email });
      setMessage(result.data.message);
      setEmail('');
    } catch (error) {
      setMessage(error.message);
    }
  };

  if (!isAdmin) {
    return <div className="admin-container">You must be an admin to view this page</div>;
  }

  return (
    <div className="admin-container">
      <h2>Admin Management</h2>
      <form onSubmit={makeAdmin} className="admin-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="User email"
          className="email-input"
        />
        <button type="submit" className="submit-button">
          Make Admin
        </button>
      </form>
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default AdminManagement;